<template>
  <Fieldset class="w-11 mb-5" :toggleable="true" :collapsed="true">
    <template #legend>
      <div class="flex align-items-center text-primary">
        <span class="font-medium">Datos laborales</span>
      </div>
    </template>
    <div class="grid">
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Empresa</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.company
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Sucursal</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.subsidiary
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Dirección</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.direction
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Gerencia</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.management
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Departamento</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.department
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Area</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.area
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Cargo</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.position
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Turno</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.shift
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Fecha de ingreso</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            formattedJoiningDate
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Causa de ingreso</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.joiningReason
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Supervisor</label>
          <span class="pt-2 font-bold" v-if="employee">
            {{ employee?.supervisor?.fullname }}
          </span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Día(s) teletrabajo</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.remoteDays
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Sueldo</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            formattedSalaryAmount
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Moneda</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.currency
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Base de sueldo</label>
          <span class="pt-2 font-bold" v-if="employee">{{
            employee?.salaryBase
          }}</span>
          <Skeleton v-else class="w-5 pt-3"></Skeleton>
        </div>
      </div>
    </div>
  </Fieldset>
</template>

<script setup lang="ts">
  import { toRefs } from 'vue'
  import type { EmployeeDetail } from '@/modules/employees/models/EmployeeDetail'

  const props = defineProps<{
    employee?: EmployeeDetail
    formattedJoiningDate: string
    formattedSalaryAmount: string | undefined
  }>()

  const { employee, formattedJoiningDate, formattedSalaryAmount } =
    toRefs(props)
</script>
